import type { NodeOperation, ProjectData } from '@/shared/types/projectData';

/**
 * Keep the history operation attached to the ID requested for this create.
 * Project nodes are stored as a flat array, so the final array element is not
 * necessarily the child inserted at a parent-relative target index.
 */
export function synchronizeCreateHistoryIdentity(
  operation: NodeOperation,
  historyOperation: NodeOperation,
  dataAfterCreate: ProjectData,
): void {
  if (operation.type !== 'create') return;

  const createdNodeId = operation.nodeId ?? operation.data?.id;
  if (!createdNodeId || !dataAfterCreate.nodes.some((node) => node.id === createdNodeId)) return;

  operation.nodeId = createdNodeId;
  operation.data = { ...(operation.data || {}), id: createdNodeId };
  historyOperation.nodeId = createdNodeId;
  historyOperation.data = { ...(historyOperation.data || {}), id: createdNodeId };
}
